module.exports = __webpack_public_path__ + "img/youtube-zzh.4b1d88a9.jpeg";